import { Box, CircularProgress, Fade, Typography  } from '@mui/material'

export const LoadingScreen = () => (
  <Fade in timeout={500}>
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        Loading KiroSupport Admin...
      </Typography>
    </Box>
  </Fade>
)
